import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { publicRequest } from '../../api/apiConfig/publicRequest';
import { showErrorNotification, showSuccessNotification } from '../../customHooks';
import { logoutAction } from '../../redux/actions/LoginActions';
import './ResetPassword.scss';
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import FormikControl from '../formikcontrols';
import { passwordRegex } from '../../utils/validation';

const ResetPassword = ({isPassOpen,closePsssModal}) => {
    const [password, setPassword] = useState({password: "", confirmpassword: "",});
    const token=window.location.search.substring(7);
    const [passwordType, setPasswordType] = useState("password");
    const [confPasswordType, setConfPasswordType] = useState("password")
    const dispatch = useDispatch();
    const navigate = useNavigate()

    var validationSchema = Yup.object().shape({
      password: Yup.string().matches(passwordRegex,"Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character").required("New Password is Required").nullable(),
      confirmpassword: Yup.string().matches(passwordRegex,"Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character").required("Confirm Password is Required").nullable(),
      
    })
    const togglePassword =()=>{
      if(passwordType=== "password")
      {
       setPasswordType("text")
       return;
      }
      setPasswordType("password")
    }
  
    const togglePassword1 =()=>{
      if(confPasswordType === "password")
      {
        setConfPasswordType("text")
       return;
      }
      setConfPasswordType("password")
    }
  
    const handleSubmit  = async (e) => {

        //e.preventDefault();
        try {
          await publicRequest.put('/user/forgot-pass-confirm', { ...e,token:token });
          showSuccessNotification("Reset password successfully")
          navigate('/')
          
    
        } catch (error) {
          showErrorNotification(error.response.data.message);
        }
      }
        
        const handleChange = async(e) => {

          dispatch(logoutAction());
          navigate('/')

            // let {value,name} = e.target;

            // setPassword(previous=>({...previous,[name]:value}))
          
          }
    return (
      <div className='creat-box1'>

        <div className='Forget_firstHalf-emailForm1'>
          <span className='title_span_Reset' style={{ textAlign: "center", color: "black" }}>Reset Password</span>

          <Formik initialValues={{
            password: "",
            newPassword: "", confPassword: ""
          }}
            validationSchema={validationSchema} onSubmit={handleSubmit}>
            <Form className="form_reset" >
              <div className="flex">
                <FormikControl

                  control="input"
                  type={passwordType}
                  name="password"
                  placeholder="Enter New Password"
                  autoComplete="off"
                  label="New Password"
                  className="inputnewReset"
                />
                <span className="icon_showpassreset" onClick={togglePassword}>
                  {passwordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                </span>
              </div>
              <div className="flex">
                <FormikControl
                  control="input"
                  type={confPasswordType}
                  name="confirmpassword"
                  placeholder="Confirm New Password"
                  autoComplete="off"
                  label="Confirm New Password"
                  className="inputconfnewReset"
                />
                <span className="icon_showpassreset" onClick={togglePassword1}>
                  {confPasswordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                </span>
              </div>
                  <div className='Forgetfirst1'>
                    <Button type='submit' className='create__Forgetsec--btn'>Reset</Button>
                    <input type='button' className='create__Forgetsec--btn' value='Cancel' onClick={handleChange} />
                </div>
            </Form>
          </Formik>
                    
                </div> 
                </div>
    );
}

export default ResetPassword